<template>
    <div id="login-wrapper">
        <div class="loginBj"></div>
        <div id="login">
            <h3>账号登录</h3>
            <el-form ref="loginForm" :model="form" :rules="rules" label-width="0px">
                <el-form-item prop="loginName">
                    <el-input v-model="form.loginName" placeholder="请输入账号/手机号"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input v-model="form.password" placeholder="请输入密码" type="password"></el-input>
                </el-form-item>
                <el-form-item>
                    <p class="forgetPass"></p>
                    <!-- <router-link to="/layout/update-pass" class="forgetPass">忘记密码</router-link> -->
                    <el-button type="primary" class="loginBtn" @click="onSubmit()" size="medium">登录</el-button>
                </el-form-item>
           </el-form>
        </div>
    </div>
  
</template>

<script>
import {
    login
} from '@services/indexService.js';
import { setCookie, delCookie} from '@/assets/utils/cookie.js'
import rulesPattern from '@/assets/utils/rulesPattern.js';
export default {
    data() {
        return {
            form: {
                loginName: '',
                password: '',
            },
            userName: '',
            companyId: '',
            ticket: '',
            type: '',
            rules: {
                loginName: [
                    { required: true, message: '请输入账号/手机号', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    // { pattern: rulesPattern.password, message: '6-20位密码，大小写加数字组合', trigger: 'blur' }
                ]
            }
        };
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
        loginName() {
            return this.$store.state.permission.loginName;
        }
    },
    created() {
        this.type = this.$route.query.type;
        if (this.type === 'exit') {
            this.delCache();
        } else {
            if (this.accountId) {
                // this.$message.info('您已登录，为')；
                this.goIndex();
            }
        }
    },
    methods: {
        onSubmit() {
            this.$refs['loginForm'].validate((valid) => {
            if (valid) {
                this.login();
            } else {
                return false;
            }
            });
        },
        login() {
            let param = {
                loginname: this.form.loginName,
                pwd: this.form.password,
            };
            login(param).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.userName = res.Data.UserName;
                    this.companyId = res.Data.CompanyId;
                    this.ticket = res.Data.Ticket;
                    this.setCache(res.Data);
                    this.goIndex();
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        goIndex() {
            this.$router.push(
                {
                    path: '/layout/index',
                }
            );
        },
        setCache(data) {
            setCookie('userName', data.UserName, 30);
            setCookie('accountId', data.AccountID, 30);
            setCookie('companyId', data.CompanyId, 30);
            setCookie('companyName', data.CompanyName, 30);
            setCookie('ticket', data.Ticket, 30);
            setCookie('loginName', data.LoginName, 30);
            setCookie('accountType', data.AccountType, 30);
            this.$store.dispatch('setLoginName', data.LoginName);
            this.$store.dispatch('setAccountId', data.AccountID);
            this.$store.dispatch('setCompanyId', data.CompanyId);
            this.$store.dispatch('setCompanyName', data.CompanyName);
            this.$store.dispatch('setAccountType', data.AccountType);
        },
        delCache() {
            delCookie('userName');
            delCookie('accountId');
            delCookie('acountType');
            delCookie('companyId');
            delCookie('companyName');
            delCookie('ticket');
            delCookie('loginName');
            delCookie('accountType');
            this.$store.dispatch('setLoginName', null);
            this.$store.dispatch('setAccountId', null);
            this.$store.dispatch('setCompanyId', null);
            this.$store.dispatch('setCompanyName', null);
            this.$store.dispatch('setAccountType', null);
        }
    },

}
</script>

<style scoped>
#login-wrapper {
    width: 100%;
    height: 650px;
    background: url('../assets/image/login.jpeg') no-repeat center;
    background-size: cover;
    padding-top: 120px;
    box-sizing: border-box;
    position: relative;
}
.loginBj {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    opacity: 0.5;
}
#login {
    width: 470px;
    height: 385px;
    margin: 0 auto;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 56px 50px;
    position: relative;
    z-index:10;
}
#login h3 {
    font-family: 思源黑体 CN;
    font-size: 22px;
    color: #262626;
    text-align: center;
    margin-bottom:30px;
}

.loginBtn {
    width: 370px;
    height: 50px;
    background: #116EBA;
    color: #fff;
    font-size: 16px;
    outline: none;
    border:none;
    cursor: pointer;
}
.loginBtn:hover{
    background: #005091;
}
.forgetPass {
    color: #86909C;
    width: 56px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    text-align: right;
    float:right;
    display:block;
    cursor: pointer;
}
.forgetPass:hover{
    color:#116EBA;
}
</style>